import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import { ButtonBaseProps } from "@mui/material/ButtonBase";
import Tooltip from "@mui/material/Tooltip";
import { ReactNode } from "react";
import { AUDIT_TOKENS } from "../../theme/auditTokens";
import { AuditButton } from "./AuditButton";

interface Props extends Omit<ButtonBaseProps, "children" | "sx"> {
  /** Accessible name and tooltip in one. */
  label: string;
  icon: ReactNode;
  /** Pressed state of a toggle; renders the button inverted. */
  active?: boolean;
  /** Small count on the icon, e.g. active column filters. */
  badge?: number;
}

/**
 * Square icon button of the page toolbar. The tooltip carries the label, so the toolbar fits on
 * one line; disabled buttons keep their tooltip through the wrapping span.
 */
export function ToolbarIconButton({ label, icon, active, badge, ...rest }: Props) {
  return (
    <Tooltip title={label}>
      <Box component="span" sx={{ display: "inline-flex" }}>
        <AuditButton
          aria-label={label}
          {...rest}
          sx={{
            p: 0,
            width: 34,
            height: 34,
            flex: "0 0 auto",
            ...(active && {
              background: AUDIT_TOKENS.ink,
              borderColor: AUDIT_TOKENS.ink,
              color: "#fff",
              "&:hover": { background: AUDIT_TOKENS.inkHover, borderColor: AUDIT_TOKENS.inkHover },
            }),
            "@media (max-width: 820px)": { minHeight: 44, width: 44, height: 44, flex: "0 0 auto" },
          }}
        >
          <Badge
            badgeContent={badge}
            color="primary"
            invisible={!badge}
            sx={{ "& .MuiBadge-badge": { fontSize: 10, height: 16, minWidth: 16, px: "4px" } }}
          >
            {icon}
          </Badge>
        </AuditButton>
      </Box>
    </Tooltip>
  );
}
